export const codingSchemes = {
    AT: "10YAT-APG------L",
    BE: "10YBE----------2",
    CZ: "10YCZ-CEPS-----N",
    HR: "10YHR-HEP------M",
    SI: "10YSI-ELES-----O",
    PL: "10YPL-AREA-----S",
    SK: "10YSK-SEPS-----K",
    FR: "10YFR-RTE------C",
    RO: "10YRO-TEL------P",
    NL: "10YNL----------L",
    HU: "10YHU-MAVIR----U",
    DE: "10YCB-GERMANY--8",
    D2: "10YDE-EON------1",
    D4: "10YDE-ENBW-----N",
    D7: "10YDE-RWENET---I",
    D8: "10YDE-VE-------2",
    AL: "10YCB-ALBANIA--1",
    MD: "10Y1001A1001A990",
    ME: "10YCS-CG-TSO---S",
    RS: "10YCS-SERBIATSOV",
    DK1: "10YDK-1--------W",
    BG: "10YCA-BULGARIA-R",
    GR: "10YCB-GREECE---2",
    MK: "10YMK-MEPSO----8",
    BA: "10YBA-JPCC-----D",
    ES: "10YES-REE------0",
    PT: "10YPT-REN------W",
    CH: "10YCB-SWITZERL-D",
    IT: "10YIT-GRTN-----B",
    UA: "10Y1001C--00003F",
    TR: "10YCB-TURKEY---V",
    BE_AL: "22Y201903144---9",
    DE_AL: "22Y201903145---4",
};
